import { useMemo } from 'react';

import { useSiteStockingAssignmentController_previewLineage } from '@/services/hooks';

import { mapStockingLineageToDomain } from './stockingAssignment.mappers';
import type { UseGetStockingLineageResult } from './stockingAssignment.types';

/** The groups that move with `fishGroupId` when its stocking changes. Always fetched fresh. */
export const useGetStockingLineage = (
    clientId: number,
    locationId: number,
    fishGroupId: number
): UseGetStockingLineageResult => {
    const query = useSiteStockingAssignmentController_previewLineage(
        clientId,
        locationId,
        fishGroupId,
        { staleTime: 0, gcTime: 0 }
    );

    const data = useMemo(
        () => (query.data?.data ? mapStockingLineageToDomain(query.data.data) : null),
        [query.data?.data]
    );

    return {
        data,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
